import { Platform } from "ionic-angular";

export default class RootPage {
  private static _page = 'Home2Page';
  private static isSF7: boolean = false;

  static setPage(platform: Platform): void {
    if (platform.is('android') || platform.is('ios')) {
      if (this.isSF7) {
        this._page = 'HomePage';
      } else {
        this._page = 'TabsPage';
      }
    }
  }

  static get page() { return this._page }
}

export function sortObject(unordered, sortArrays = false) {
  if (!unordered || typeof unordered !== 'object') {
    return unordered;
  }

  if (Array.isArray(unordered)) {
    const newArr = unordered.map((item) => sortObject(item, sortArrays));
    if (sortArrays) {
      newArr.sort();
    }
    return newArr;
  }

  const ordered = {};
  Object.keys(unordered)
    .sort()
    .forEach((key) => {
      ordered[key] = sortObject(unordered[key], sortArrays);
    });
  return ordered;
}

export function isJSON(obj: any) {
  if (typeof obj === 'string') {
    // obj is string, parse it using JSON.parse()
    try {
      const isJSON = JSON.parse(obj);
      // this is for null, as 'null' is a valid JSON and type of null is object
      // but 'null' is itself falsey
      // if isJSON is null then if( isJSON && ... ) will be false
      if (isJSON && typeof isJSON === 'object') {
        // everything goes fine, return true
        return true;
      }

      return false;
    } catch (e) {
      // cannot parse, invalid JSON
      return false;
    }
  } else {
    // 'obj' is not string, so first,
    // JSON.stringify() it, then parse
    const jsonString = JSON.stringify(obj);
    // now parse this json string
    try {
      const checkJSON = JSON.parse(jsonString);
      // this is for null, as 'null' is a valid JSON and type of null is object
      // but 'null' is itself falsey
      // if isJSON is null then if( isJSON && ... ) will be false
      if (checkJSON && typeof checkJSON === 'object') {
        // everything goes fine, return true
        return true;
      }

      return false;
    } catch (e) {
      // cannot parse, invalid JSON
      return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/root-page.helper.ts